import { render, staticRenderFns } from "./webPopupBlock.vue?vue&type=template&id=64c6c00f&"
import script from "./webPopupBlock.vue?vue&type=script&lang=js&"
export * from "./webPopupBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports